module.exports = __webpack_public_path__ + "static/AzoSans-Bold-194eb28b5284901507c079c595c59475.ttf";